import { FilterBar, FilterDateRange, FilterSingleSelect } from "components";
import { InvoicedSiigo } from "enums";
import React, { useCallback, useMemo } from "react";
import { prettifyInvoiced } from "services/pretty.service";
import lang from "translations";

const InvoiceFilter = ({ filterState, modifyFilter, clearFilter, applyFilter, loading, maxLength = 75 }) => {
  const invoicedOptions = useMemo(
    () =>
      [
        InvoicedSiigo.Unbill,
        InvoicedSiigo.SiigoError,
        InvoicedSiigo.SiigoAccepted,
        InvoicedSiigo.DianError,
        InvoicedSiigo.DianAccepted,
        InvoicedSiigo.PendingUnbill,
      ].map((e) => ({
        value: e,
        text: prettifyInvoiced(e),
      })),
    []
  );

  const stateOptions = useMemo(
    () => [{ value: "", text: lang.allState }, ...invoicedOptions],
    [invoicedOptions]
  );

  const applyFilterCb = useCallback(
    async (searchKey) => {
      await applyFilter(searchKey);
    },
    [applyFilter]
  );

  const clearFilterCb = useCallback(() => {
    clearFilter();
  }, [clearFilter]);

  return (
    <FilterBar
      placeholder={lang.searchEInvoicePlaceholder}
      className="mb-lg"
      onClear={clearFilterCb}
      onApply={applyFilterCb}
      filterState={filterState}
      loading={loading}
      maxLength={maxLength}
    >
      <FilterDateRange
        id="dateRange"
        label={lang.dates}
        value={filterState.dateRange}
        onChange={(value) => modifyFilter("dateRange", { value })}
      />
      <FilterSingleSelect
        id="state"
        label={lang.state}
        summaryFallback={lang.allState}
        options={stateOptions}
        value={filterState.state}
        onChange={(value) => modifyFilter("state", { value })}
      />
    </FilterBar>
  );
};

export default InvoiceFilter;
